<ul #ul [appShow]="state.visible">
  <li *ngFor="let result of state.results; trackBy: trackByValue"
      (click)="onClickResult(result)"
      [ngClass]="{ selected: isSelected(result) }">{{ result.description }}</li>
</ul>
